// utils/colors.js or constants/colors.js

export const blueShades = ['#4B77BE', '#5CACEE', '#1E90FF', '#6495ED', '#4169E1', '#0000CD'];
